import { TechnicalCommitteeNewsCardComponent } from './../technical-committee-news-card/technical-committee-news-card.component';
import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NgbCarouselModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PageHeaderComponent } from '../../core/components/page-header/page-header.component';
import { DownloadImageDirective } from '../../core/directives/download-image.directive';
import { LanguageEnum } from '../../core/enums/languageEnum';
import { PublicService } from '../../core/services/public.service';
import { LeagueAchievementResponse, LeagueMemberResponse, NewsResponse } from '../technical-committee.interface';
import { TechnicalCommitteeService } from '../technical-committee.service';
import { leagueEnum } from '../league.enum';
import { CustomDatePipe } from '../../core/custom-date.pipe';
import { LeagueSubscriptionComponent } from '../league-subscription/league-subscription.component';

@Component({
  selector: 'app-arab-insurance-brokers-league',
  standalone: true,
  imports: [TechnicalCommitteeNewsCardComponent, PageHeaderComponent, TranslateModule, CommonModule, NgbCarouselModule, CustomDatePipe, DownloadImageDirective],
  providers: [DatePipe],
  templateUrl: './arab-insurance-brokers-league.component.html',
  styleUrl: './arab-insurance-brokers-league.component.scss'
})
export class ArabInsuranceBrokersLeagueComponent implements OnInit, OnDestroy {

  isArabic: boolean = false;
  publicService = inject(PublicService);
  translateService = inject(TranslateService);
  technicalCommitteeService = inject(TechnicalCommitteeService);
  subscription = new Subscription();
  achievementList: LeagueAchievementResponse[] = [];
  memberList: LeagueMemberResponse[] = [];
  newsList: NewsResponse[] = [];
  title: string = 'technicalCommittee.arabInsuranceBrokersLeague';

  constructor(private datePipe: DatePipe, private modalService: NgbModal) { }
  //#region 
  ngOnInit(): void {
    let currentLanguage = this.publicService.getAppCurrentLanguage();
    this.isArabic = currentLanguage == 'en' ? false : true;
    this.getLeagueAchievementWebsite();
    this.getLeagueMemberWebsiteList();
    this.getNews();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  //#endregion

  //#region Methods
  getLeagueAchievementWebsite() {
    this.subscription.add(this.technicalCommitteeService.getBrokerLeagueAchievementWebsite().subscribe(res => {
      this.achievementList = res;
    }))
  }
  getLeagueMemberWebsiteList() {
    this.subscription.add(this.technicalCommitteeService.getLeagueMemberWebsiteList().subscribe(res => {
      this.memberList = res.filter(x => x.leagueId == leagueEnum.Broker);
    }))
  }
  getNews() {
    this.subscription.add(this.technicalCommitteeService.getBrokerLeaguePageNews(this.isArabic ? LanguageEnum.Arabic : LanguageEnum.English).subscribe(res => {
      this.newsList = res;
    }))
  }
  downloadAttachedPDF(item: LeagueAchievementResponse) {
    this.publicService.displayPDF((this.isArabic ? item.pdfArFullPath : item.pdfEnFullPath), "show")
  }

  downloadAttachedNewsPDF(item: NewsResponse) {
    this.publicService.displayPDF(item.pdfFullPath, "show")
  }

  subscribe() {
    let subscriptionCompanyComponent = this.modalService.open(LeagueSubscriptionComponent,
      { centered: true, backdrop: 'static', modalDialogClass: 'rounded-module', size: 'xl' });
    subscriptionCompanyComponent.result.then((res) => {
      if (res) {
      }
    }).catch((err) => { })
  }

  //#endregion

}
